import { render, staticRenderFns } from "./BaseInputArea.vue?vue&type=template&id=5e859ca6&"
import script from "./BaseInputArea.vue?vue&type=script&lang=js&"
export * from "./BaseInputArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e859ca6')) {
      api.createRecord('5e859ca6', component.options)
    } else {
      api.reload('5e859ca6', component.options)
    }
    module.hot.accept("./BaseInputArea.vue?vue&type=template&id=5e859ca6&", function () {
      api.rerender('5e859ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputArea.vue"
export default component.exports